import React, {ReactNode} from 'react'
import {TableRowName} from '../../../../../styledComponents/adminPage/Table'
import {
    HOURS,
    HOURS_24,
    RESERVATION_TIME_UNIT_MINUTES,
    UNIT_OF_BUSINESS_SCHEDULE,
    UNIT_TIME,
    VALID_OR_NOT,
} from '../../../../../CodeMaster'
import {AdminDefaultMediumButton} from '../../../../../styledComponents/adminPage/Buttons'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BusinessScheduleCharge} from './BusinessScheduleChargeComponent'
import {
    checkBusinessScheduleSettings,
    checkNewTimeTableItem,
    makeTimeTableItem,
} from './BusinessScheduleSettingsComponentHelper'
import {TimeTableItem} from '../BusinessScheduleItemInterfaces'
import BusinessScheduleInputForm from './BusinessScheduleInputForm'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {NoSelectedValue} from '../../../../../componentHelper/selectHelper'

import { TableRow, TableCell } from '@mui/material';

interface Props {
    timeTableItems: TimeTableItem[]
    onChangeBusinessSchedule: (items: TimeTableItem[]) => void
}

export interface BusinessScheduleSettings {
    businessScheduleUnit: Nullable<UNIT_OF_BUSINESS_SCHEDULE>,
    dateStraddle: VALID_OR_NOT,
    joinPrevDaysSchedule: VALID_OR_NOT,
    startTimeHour: Nullable<HOURS>,
    startTimeMinute: Nullable<RESERVATION_TIME_UNIT_MINUTES>,
    endTimeHour: Nullable<HOURS | HOURS_24>,
    endTimeMinute: Nullable<RESERVATION_TIME_UNIT_MINUTES>,
    changedChargeApplyStartTime: Nullable<number>,
    changedChargeApplyStartTimeUnit: UNIT_TIME,
    charge: BusinessScheduleCharge
    changedCharge: BusinessScheduleCharge
}

export interface BusinessScheduleSettingsAndState extends BusinessScheduleSettings {
    businessSchedulePattern: string
    dayOfWeek: string
}

interface State extends BusinessScheduleSettingsAndState {
    errorMessage: Nullable<string>
}

class BusinessScheduleInput extends React.Component<Props, State> {

    static displayName: string = 'BusinessScheduleInput'

    initialData: BusinessScheduleSettings = {
        businessScheduleUnit: null,
        dateStraddle: VALID_OR_NOT.NOT,
        joinPrevDaysSchedule: VALID_OR_NOT.NOT,
        startTimeHour: null,
        startTimeMinute: null,
        endTimeHour: null,
        endTimeMinute: null,
        changedChargeApplyStartTime: null,
        changedChargeApplyStartTimeUnit: UNIT_TIME.HOUR,
        charge: {
            charge: null,
            chargeUnit: UNIT_TIME.MINUTES,
            chargeUnitTime: null,
            fixedCharge: false,
        },
        changedCharge: {
            charge: null,
            chargeUnit: UNIT_TIME.MINUTES,
            chargeUnitTime: null,
            fixedCharge: false,
        },
    }

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            ...this.initialData,
            businessSchedulePattern: NoSelectedValue,
            dayOfWeek: UNIT_OF_BUSINESS_SCHEDULE.SUNDAY.value,
            errorMessage: null,
        }

        this.handleDataChange = this.handleDataChange.bind(this)
        this.handleAddButtonClick = this.handleAddButtonClick.bind(this)
    }

    handleAddButtonClick(): void {
        const {dayOfWeek, businessSchedulePattern, errorMessage, ...rest} = this.state
        const newTimeTableItem: Nullable<TimeTableItem> = makeTimeTableItem({...rest})
        if (newTimeTableItem === null) {
            return
        }

        const errorMessageString: Nullable<string> =
            checkNewTimeTableItem(newTimeTableItem, this.props.timeTableItems)
        if (errorMessageString !== null) {
            this.setState({errorMessage: errorMessageString})
            return
        }

        this.props.onChangeBusinessSchedule([...this.props.timeTableItems, newTimeTableItem])

        this.setState({errorMessage: null})
    }

    handleDataChange(data: BusinessScheduleSettingsAndState): void {
        this.setState({
            ...data,
            errorMessage: null,
        })
    }

    render(): ReactNode {
        return (<>
            <TableRow>
                <TableRowName required>営業スケジュール設定</TableRowName>
                <TableCell>
                    <BusinessScheduleInputForm
                        data={{...this.state}}
                        onChange={this.handleDataChange}
                    />
                    <AdminDefaultMediumButton
                        onClick={this.handleAddButtonClick}
                        disabled={!checkBusinessScheduleSettings(this.state)}>
                        営業スケジュール追加
                    </AdminDefaultMediumButton>
                    {
                        this.state.errorMessage &&
                        <ErrorLabel>
                            {this.state.errorMessage}
                        </ErrorLabel>
                    }
                </TableCell>
            </TableRow>
        </>)
    }
}

export default BusinessScheduleInput

const ErrorLabel = styled.label`
  margin-left: 20px;
  color: ${Colors.Alert};
`
